import { inject, watch } from '@vue/runtime-core';
import { useRoute } from "vue-router";
import { memberService } from '@/utils';
export default {
  name: "Login",
  setup() {
    const route = useRoute();
    const {
      member
    } = inject("store");
    const loginUrl = memberService.getRLloginUrl();
    watch(() => route.fullPath, () => {
      member.mutations.setIsNotAuth(false);
    });
    return {
      loginUrl
    };
  }
};